<!--
 * @Author: your name
 * @Date: 2021-11-16 09:36:33
 * @LastEditTime: 2021-11-16 10:04:52
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/pages/arkHome/components/ztList.vue
-->
<!--  -->
<template>
  <div class="zt-index">
    <div class="main-img" @click="openZt(5)">
      <img :src="ztlist[4].img" alt="" />
    </div>
    <ul class="zt-list">
      <li v-for="(item, index) in ztlist.slice(0, 4)" :key="index" @click="openZt(index)">
        <img :src="item.img" alt="" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ztlist: [
        {
          url: 'https://mobile.iqihang.com/zt/23qnjx/',
          img: require('@/assets/img/arkHome/zt-img2.png'),
        },
        {
          url: 'https://mobile.iqihang.com/zt/23lxjh/',
          img: require('@/assets/img/arkHome/zt-img3.png'),
        },
        {
          url: 'https://mobile.iqihang.com/zt/23sqjx/',
          img: require('@/assets/img/arkHome/zt-img4.png'),
        },
        {
          url: 'https://mobile.iqihang.com/zt/23bnjx/',
          img: require('@/assets/img/arkHome/zt-img5.png'),
        },
        {
          url: 'https://mobile.iqihang.com/zt/23msk/',
          img: require('@/assets/img/arkHome/main-img.png'),
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    openZt(idx) {
      const data = this.ztlist[idx];
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url: data.url }, false);
        return;
      }
      window.open(data.url);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.zt-index{
  padding-top: 20px;
}
.main-img {
  display: block;
  width: 675px;
  margin: 0 auto;
  > img {
    width: 675px;
    height: 275px;
  }
}
.zt-list {
  display: block;
  width: 680px;
  margin: 14px auto;
  padding-bottom: 20px;
  li {
    width: 100%;
    margin-bottom: 10px;
    > img {
      width: 680px;
      height: 282px;
    }
  }
}
</style>
